// third-party
import { FormattedMessage } from "react-intl";

// assets
import {
  IconApps,
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
} from "@tabler/icons";

// constant
const icons = {
  IconApps,
  IconUserCheck,
  IconBasket,
  IconMessages,
  IconLayoutKanban,
  IconMail,
  IconCalendar,
  IconNfc,
};

// ==============================|| menus MENU ITEMS ||============================== //
// const menus = {
//     id: 'application',
//     title: <FormattedMessage id="application" />,
//     icon: icons.IconApps,
//     type: 'group',
//     children: [
//         {
//             id: 'Master Setup',
//             title: <FormattedMessage id="Master Setup" />,
//             type: 'collapse',
//             icon: icons.IconUserCheck,
//             children: [
//                 {
//                     id: 'Program',
//                     title: <FormattedMessage id="Program" />,
//                     type: 'item',
//                     url: '/program/list'
//                 },
//                 {
//                     id: 'Batch',
//                     title: <FormattedMessage id="Batch" />,
//                     type: 'item',
//                     url: '/batch/list'
//                 },
//                 {
//                     id: 'Branch',
//                     title: <FormattedMessage id="Branch" />,
//                     type: 'item',
//                     url: '/branch/list'
//                 },
//             ]
//         },
//     ]
// };

const menus = {
  id: "application",
  // title: <FormattedMessage id="application" />,
  icon: icons.IconApps,
  type: "group",
  children: [],
};
const LOCAL_TEST_BRAND = "entrarDemo";
const hostname = typeof window !== "undefined" ? window.location.hostname : "";
const isLocalhost = hostname.includes("localhost");

let subdomain = "";
if (!isLocalhost) {
  subdomain = hostname.split(".").length > 2 ? hostname.split(".")[0] : "";
} else {
  subdomain = LOCAL_TEST_BRAND;
}


const checkInstitutionType =
  localStorage.getItem("institutionType") === "School";

const SuperAdminMenu = () => {
  const MenusData = [
    {
      id: "Dashboard",
      title: <FormattedMessage id="Dashboard" />,
      type: "item",
      icon: "https://github.com/user-attachments/assets/fab2f4ad-59bc-42b1-ba12-a25bca1e5de6",
      url: "/dashboard/analytics",
      breadcrumbs: false,
      target: false,
      children: [],
    },
    {
      id: "Institute",
      title: <FormattedMessage id="Institute Registration" />,
      type: "item",
      icon: "https://github.com/chhavientrar/imageslink/assets/124863903/fe75398f-bd45-41d8-b26f-0c31ee20f9d0",
      url: "/institute",
      breadcrumbs: false,
      target: false,
      children: [],
    },
    {
      id: "Menu Setup",
      title: <FormattedMessage id="Menu Setup" />,
      type: "collapse",
      icon: "https://github.com/chhavientrar/imageslink/assets/124863903/e74e2b66-32df-4edf-a15f-bd512dae7ec0",
      children: [
        {
          id: "Module",
          title: <FormattedMessage id="Module" />,
          type: "item",
          url: "/module/list",
        },
        {
          id: "Menu Permission",
          title: <FormattedMessage id="Menu Permission" />,
          type: "item",
          url: "/menu/permission/list",
        },
        {
          id: "Report Reason Setup ",
          title: <FormattedMessage id="Report Reason Setup" />,
          type: "item",
          url: "/report-master",
        },
      ],
    },
  ];
  menus.children = MenusData;
};

const StaticMenus = () => {
  const MenusData = [
    {
      id: "Dashboard",
      title: <FormattedMessage id="Dashboard" />,
      type: "item",
      icon: "https://github.com/user-attachments/assets/81312246-6cf2-45fb-99b5-a9c9fc7390eb",
      url: "/institute/dashboard",
      breadcrumbs: false,
      target: false,
      children: [],
    },

    {
      id: "Alumni",
      title: <FormattedMessage id="Alumni" />,
      type: "collapse",
      icon: "https://github.com/user-attachments/assets/fab2f4ad-59bc-42b1-ba12-a25bca1e5de6",
      breadcrumbs: false,
      children: [
        {
          id: "PendingApplication",
          title: <FormattedMessage id="Pending Applications" />,
          type: "item",
          url: "/pending/application",
        },
        {
          id: "PendingSocialPost",
          title: <FormattedMessage id="Pending Post" />,
          type: "item",
          url: "/pending/post",
        },
        {
          id: "PendingVideos",
          title: <FormattedMessage id="Video Post" />,
          type: "item",
          url: "/pending/alumni-videos",
        },
        {
          id: "PendingSocialPost",
          title: <FormattedMessage id="AI Approved Post" />,
          type: "item",
          url: "/ai/approved/post",
        },
        {
          id: "AlumniDirectory",
          title: <FormattedMessage id="Alumni Directory" />,
          type: "item",
          url: "/alumni/register",
        },
        {
          id: "AlumniGroup",
          title: <FormattedMessage id="Alumni Group" />,
          type: "item",
          url: "/groups",
        },

        {
          id: "PendingStarAlumni",
          title: <FormattedMessage id="Pending Star-Alumni" />,
          type: "item",
          url: "/pending/star-alumni",
        },
        {
          id: "RaisedIssues",
          title: <FormattedMessage id="Help Requests" />,
          type: "item",
          url: "/raised-issues",
        },
        {
          id: "Mentor-Mentee",
          title: <FormattedMessage id="Mentor-Mentee Report" />,
          type: "item",
          url: "/mentor-mentee/report",
        },
      ],
    },
    {
      id: "Event",
      title: <FormattedMessage id="Event" />,
      type: "collapse",
      icon: "https://github.com/user-attachments/assets/3a8f564e-35ed-4976-85bf-c94c25ff70c7",
      children: [
        {
          id: "Event List",
          title: <FormattedMessage id="Event List" />,
          type: "item",
          url: "/createvent",
        },
        {
          id: "Event Approvals",
          title: <FormattedMessage id="Event Approval" />,
          type: "item",
          url: "/approvals",
        },
        {
          id: "EventType",
          title: <FormattedMessage id="Event Type" />,
          type: "item",
          url: "/eventType/list",
        },
        {
          id: "EventBadge",
          title: <FormattedMessage id="Event Badge" />,
          type: "item",
          url: "/event/badge",
        },
      ],
    },
    {
      id: "Announcements",
      title: <FormattedMessage id="Announcement" />,
      type: "collapse",
      icon: "https://github.com/user-attachments/assets/6cfe2a7f-1f15-49fc-b301-8991314d599c",
      children: [
        {
          id: "Announcements",
          title: <FormattedMessage id="Announcements" />,
          type: "item",
          url: "/announcements",
        },
        {
          id: "Notificationsszzz",
          title: <FormattedMessage id="Notifications" />,
          type: "item",
          url: "/additional/notification",
        },
      ],
    },

    {
      id: "Users",
      title: <FormattedMessage id="Users" />,
      type: "item",
      icon: "https://github.com/user-attachments/assets/6cfe2a7f-1f15-49fc-b301-8991314d599c",
      url: "/user/list",
      breadcrumbs: false,
      target: false,
      children: [],
    },

    {
      id: "Master Setup",
      title: <FormattedMessage id="Master Setup" />,
      type: "collapse",
      icon: "https://github.com/user-attachments/assets/78cf872a-bc24-4f01-a504-97f54db31806",
      children: [
        {
          id: checkInstitutionType ? "Standard" : "Program",
          title: (
            <FormattedMessage
              id={checkInstitutionType ? "Standard" : "Program"}
            />
          ),
          type: "item",
          url: "/program/list",
        },
        {
          id: "Batch",
          title: <FormattedMessage id="Batch" />,
          type: "item",
          url: "/batch/list",
        },

        {
          id: 'Branch',
          title: <FormattedMessage id="Branch" />,
          type: 'item',
          url: '/branch/list',
        },

        {
          id: "Industries",
          title: (
            <FormattedMessage
              id="Industries"
            />
          ),
          type: "item",
          url: "/industries/list",
        },
        {
          id: "Functional Area",
          title: <FormattedMessage id="Functional Area" />,
          type: "item",
          url: "/functional-area/list",
        },
        {
          id: "Video Category",
          title: <FormattedMessage id="Video Category" />,
          type: "item",
          url: "/video-category/list",
        },
      ],
    },
    {
      id: "Fee Setup",
      title: <FormattedMessage id="Fee Setup" />,
      type: "collapse",
      icon: "https://github.com/user-attachments/assets/78cf872a-bc24-4f01-a504-97f54db31806",
      children: [
        {
          id: "Fee Head",
          title: <FormattedMessage id="Fee Head" />,
          type: "item",
          url: "/fee-head",
        },
        {
          id: "Fee Mapping",
          title: <FormattedMessage id="Fee Mapping" />,
          type: "item",
          url: "/fee-mappings",
        },
      ],
    },

    {
      id: "Settings",
      title: <FormattedMessage id="Settings" />,
      type: "item",
      // https://github.com/chhavientrar/imageslink/assets/124863903/2bb7b10d-0770-473d-bb7c-1f31f9da25de
      icon: "https://github.com/user-attachments/assets/9f755ee0-4ebb-440c-a9c1-e318773d66a0",
      url: "/setting",
      breadcrumbs: false,
      target: false,
      children: [],
    },
  ];
  menus.children = MenusData;
};
const AlumniMenus = () => {
  // const MenusData = [
  //   {
  //     id: "Dashboard",
  //     title: <FormattedMessage id="Dashboard" />,
  //     type: "item",
  //     // icon: icons.IconUserCheck,
  //     url: "/alumni/profile",
  //     breadcrumbs: false,
  //     target: false,
  //     children: [],
  //   },
  //   {
  //     id: "Batch",
  //     title: <FormattedMessage id="Batch" />,
  //     type: "item",
  //     // icon: icons.IconUserCheck,
  //     url: "/alumnidetails/batch/list",
  //     breadcrumbs: false,
  //     target: false,
  //     children: [],
  //   },
  //   {
  //     id: "Social",
  //     title: <FormattedMessage id="Social" />,
  //     type: "item",
  //     // icon: icons.IconUserCheck,
  //     url: "/socialprofile",
  //     breadcrumbs: false,
  //     target: false,
  //     children: [],
  //   },
  //   // {
  //   //   id: "social",
  //   //   title: <FormattedMessage id="Social" />,
  //   //   type: "collapse",
  //   //   children: [
  //   //     {
  //   //       id: "Social Profile",
  //   //       title: <FormattedMessage id="Social Profile" />,
  //   //       type: "item",
  //   //       url: "/socialprofile",
  //   //     },
  //   //   ],
  //   // },
  // ];
  // menus.children = MenusData;
};

const role = localStorage.getItem("role");

if (role === "ROLE_SUPER_ADMIN") {
  SuperAdminMenu();
} else if (role === "ROLE_COLLEGE_ADMIN" || "ROLE_COLLEGE_ADMIN") {
  StaticMenus();
} else if (role === "ROLE_ALUMNI") {
  AlumniMenus();
} else {
  console.log("lkjhgfdsfghjk");
}

export default menus;
